import React, { useRef } from "react";
import { Col, Row } from "react-bootstrap";
import BootstrapTable from "src/components/BootstrapTable";
import DetailButton from "src/components/DetailButton";
import Title from "src/components/Title";

const SearchOverviewSite = () => {
  const table = useRef();

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Title>Such-Übersicht</Title>
        </Col>
      </Row>
      <Row>
        <Col>
          <BootstrapTable
            url="/api/backend/searches"
            sort="updated_at"
            order="desc"
            ref={table}
            showSearch
            showClear
            showRefresh
            showFilter
            cache
            pageSize={25}
            pageSizes={[25, 50, 100, 250]}
            columns={[
              {
                field: "id",
                name: "Such-ID",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "swipetype_id",
                name: "Swipetyp",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "search_latitude",
                name: "Latitude",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "search_longitude",
                name: "Longitude",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "location",
                name: "Ort",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "id",
                textAlign: "right",
                width: 120,
                formatter: (value) => {
                  return (
                    <React.Fragment>
                      <DetailButton url={`/search/${value}`} />{" "}
                    </React.Fragment>
                  );
                },
              },
            ]}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default SearchOverviewSite;
